"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ModalFooterDesktop = require("./ModalFooterDesktop");
Object.keys(_ModalFooterDesktop).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ModalFooterDesktop[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ModalFooterDesktop[key];
    }
  });
});